import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
	list: [],
	loading: false,
	error: ''
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
	case actionTypes.FETCH_CUSTOM_CHANNELS_BEGIN:
		return updateObject(state, {
			loading: true,
			error: ''
		});
	case actionTypes.FETCH_CUSTOM_CHANNELS_SUCCESS:
		return updateObject(state, {
			loading: false,
			list: action.payload
		});
	case actionTypes.FETCH_CUSTOM_CHANNELS_FAILED:
		return updateObject(state, {
			loading: false,
			error: 'ERROR'
		});
	default:
		return state;
	}
};

export default reducer;
